import React from "react";

import { Row, Col } from "antd";
import StockMovementHistoryReport from "../../Report/StockMovementHistoryReport";
import StockTotal from "../HomeComponent/Stock/StockTotal";
import StockMonthlyTotal from "../HomeComponent/Stock/StockMonthlyTotal";
import TransactionProjectTypeTotal from "../HomeComponent/Stock/TransactionProjectTypeTotal";
import TransactionProjectTypeMonthlyTotal from "../HomeComponent/Stock/TransactionProjectTypeMonthlyTotal";
import { useEffect, useState } from "react";
import RequestHandler from "util/RequestHandler";

const StockHome = () => {
  const [dashBoardData, setDashboardData] = useState({
    loading: false,
    stockTotal: 0,
    stockMonthlyTotal: 0,
    transactionProjectTypeTotal: 0,
    transactionProjectTypeMonthlyTotal: 0,
  });

  useEffect(() => getData(), []);

  const getData = () => {
    setDashboardData({
      ...dashBoardData,
      loading: true,
    });
    RequestHandler.get("/StockDashboard").then((response) => {
      setDashboardData({
        stockTotal: response.totalStockCount,
        stockMonthlyTotal: response.monthlyTotalStockCount,
        transactionProjectTypeTotal: response.totalTransactionProjectTypeCount,
        transactionProjectTypeMonthlyTotal:
          response.monthlyTotalTransactionProjectTypeCount,
        loading: false,
      });
    });
  };

  return (
    <>
      <Row>
        <StockTotal data={dashBoardData.stockTotal} />
        <StockMonthlyTotal data={dashBoardData.stockMonthlyTotal} />
        <TransactionProjectTypeTotal
          data={dashBoardData.transactionProjectTypeTotal}
        />
        <TransactionProjectTypeMonthlyTotal
          data={dashBoardData.transactionProjectTypeMonthlyTotal}
        />
      </Row>
      <Row>
        <Col span={24}>
          <StockMovementHistoryReport />
        </Col>
      </Row>
    </>
  );
};
export default StockHome;
